import * as React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Card as MuiCard,
  Switch,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
interface NotificationScreenProps {
  handleNotificationSetting: () => void;
}
function AppNotificationSetting({handleNotificationSetting}:NotificationScreenProps) {
  const classes = useStyles();
  const [notificationEnabled, setNotificationEnabled] = React.useState(true);
  const [selectedTypes, setSelectedTypes] = React.useState(["push"]);
  const [frequency, setFrequency] = React.useState("instant");

  const handleTypeChange = (type) => {
    const newTypes = selectedTypes.includes(type)
      ? selectedTypes.filter((t) => t !== type)
      : [...selectedTypes, type];
    setSelectedTypes(newTypes);
  };

  return (
    <div className={classes.container}>
      <MuiCard className={classes.card}>
        <Box className={classes.header}>
            <img src={backIcon} alt="Back" className={classes.backIcon} onClick={handleNotificationSetting}/>
          <img src={logo} alt="Logo" className={classes.logo} />
        </Box>

      <Typography variant="h5" style={{color:"#2158D0", fontWeight:700, fontFamily: "MontserratRegular", fontSize: "30px", display:"flex", justifyContent:"center"     }}>
          Setting and Preferences         
          </Typography>
  

        <List className={classes.settingsList}>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary="Notification Setting"
              primaryTypographyProps={{ className: classes.sectionTitle }}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary="Allow Notification"
              primaryTypographyProps={{ className: classes.sectionTitle }}
            />
            <Switch
              checked={notificationEnabled}
              onChange={(e) => setNotificationEnabled(e.target.checked)}
              color="primary"
              className={classes.switchBtn}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary="Notification Types"
              primaryTypographyProps={{ className: classes.sectionTitle }}
              secondaryTypographyProps={{ className: classes.sectionSubtitle }}
            />
          </ListItem>
          {["push", "email"].map((type) => (
            <ListItem key={type} className={classes.notificationItem}>
              <ListItemText
                primary={type === "push" ? "Push Notification" : "Email Alert"}
                primaryTypographyProps={{ className: classes.sectionTitle }}
              />
              <Switch
                checked={selectedTypes.includes(type)}
                onChange={(e) => handleTypeChange(type)}
                color="primary"
                className={classes.switchBtn}
              />
            </ListItem>
          ))}

          <ListItem className={classes.listItem}>
            <ListItemText
              primary="Notification Frequency"
              primaryTypographyProps={{ className: classes.sectionTitle }}
              secondaryTypographyProps={{ className: classes.sectionSubtitle }}
            />
          </ListItem>
          <RadioGroup
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
            className={classes.radioGroup}
          >
            {["instant", "hourly", "daily", "weekly"].map((freq) => (
              <FormControlLabel
                key={freq}
                value={freq}
                control={
                  <Radio
                    classes={{
                      root: classes.radioRoot,
                      checked: classes.radioRoot,
                    }}
                  />
                }
                label={freq.charAt(0).toUpperCase() + freq.slice(1)}
                className={classes.radioLabel}
              />
            ))}
          </RadioGroup>
        </List>
        <Box className={classes.buttonContainer}>
          <Button variant="contained" className={classes.saveButton}>
            Save Changes
          </Button>
       
        </Box>
      </MuiCard>
    </div>
  );
}

export default AppNotificationSetting;
